import { Layout, Menu } from "antd";
import { useNavigate } from "react-router-dom";
import {
  BarChartOutlined,
  CrownOutlined,
  DollarOutlined,
  LineChartOutlined,
  RobotOutlined,
  SettingOutlined,
  ThunderboltOutlined,
} from "@ant-design/icons";

export interface IMenu {
  key: string;
  icon?: React.ReactNode;
  label: string;
  children?: IMenu[];
}

// 신규 정보구조 (v2 계획서 3.3절)
export const menuData: IMenu[] = [
  { key: "dashboard", icon: <CrownOutlined />, label: "대시보드" },
  {
    key: "finance",
    icon: <DollarOutlined />,
    label: "자산관리",
    children: [
      { key: "inout", label: "카드/입출금" },
      { key: "analysis", label: "분석" },
      { key: "assets", label: "자산현황" },
      { key: "rental", label: "임대 관리" },
      { key: "retirement-sim", label: "은퇴시뮬레이터" },
      { key: "pension-tax-sim", label: "연금 시뮬레이션" },
    ],
  },
  {
    key: "investment",
    icon: <BarChartOutlined />,
    label: "투자",
    children: [
      { key: "portfolio", label: "포트폴리오" },
      { key: "stocks", label: "주식" },
      { key: "funds", label: "펀드" },
      { key: "money-markets", label: "머니마켓" },
      { key: "trade-timings", label: "매매 시점" },
      { key: "insights", label: "AI 인사이트" },
    ],
  },
  {
    key: "research",
    icon: <LineChartOutlined />,
    label: "시장 분석",
    children: [
      { key: "market-desk", label: "시장 데스크" },
      { key: "screener", label: "종목 발굴" },
      { key: "market-insights", label: "종목 조사" },
      { key: "contest", label: "투자 대결" },
    ],
  },
  {
    key: "trading",
    icon: <ThunderboltOutlined />,
    label: "트레이딩",
    children: [
      { key: "quant", label: "퀀트" },
      { key: "kis", label: "한투 투자" },
      { key: "nh", label: "NH 투자" },
    ],
  },
  { key: "assistant", icon: <RobotOutlined />, label: "AI 어시스턴트" },
  {
    key: "settings",
    icon: <SettingOutlined />,
    label: "설정",
    children: [
      { key: "categories", label: "카테고리 설정" },
      { key: "notifications", label: "알림 내역" },
      { key: "notification-patterns", label: "알림 패턴정의" },
      { key: "holidays", label: "휴장일 관리" },
    ],
  },
];

/** 메뉴 key → 라우트 경로 매핑 */
export const menuRouteMap: Record<string, string> = {
  dashboard: "/dashboard",
  contest: "/research/contest",
  inout: "/finance/inout",
  analysis: "/finance/analysis",
  assets: "/finance/assets",
  rental: "/finance/rental",
  "retirement-sim": "/finance/retirement-sim",
  "pension-tax-sim": "/finance/pension-tax-sim",
  portfolio: "/investment/portfolio",
  stocks: "/investment/stocks",
  funds: "/investment/funds",
  "money-markets": "/investment/money-markets",
  insights: "/investment/insights",
  "market-insights": "/research/market-insights",
  "market-desk": "/research/market-desk",
  screener: "/research/screener",
  "trade-timings": "/research/trade-timings",
  quant: "/trading/quant",
  kis: "/trading/kis",
  nh: "/trading/nh",
  assistant: "/assistant",
  categories: "/settings/categories",
  notifications: "/settings/notifications",
  "notification-patterns": "/settings/notification-patterns",
  holidays: "/settings/holidays",
};

const MainMenu = ({
  selectedKeys,
  openKeys,
  onOpenChange,
  onNavigate,
}: {
  selectedKeys?: string[];
  openKeys?: string[];
  onOpenChange?: (keys: string[]) => void;
  onNavigate?: () => void;
}) => {
  const navigate = useNavigate();

  return (
    <Menu
      mode="inline"
      style={{ borderInlineEnd: "none", paddingTop: 8 }}
      items={menuData as any}
      selectedKeys={selectedKeys}
      openKeys={openKeys}
      onOpenChange={(keys) => onOpenChange?.(keys as string[])}
      onClick={({ key }) => {
        const path = menuRouteMap[key];
        if (path) {
          navigate(path);
          onNavigate?.();
        }
      }}
    />
  );
};

export default MainMenu;
